import React, { useState } from 'react'
import { Mail, Users } from 'lucide-react'
import { Avatar, AvatarImage, AvatarFallback } from 'components/ui/avatar'
import CommunicationPartnersCN from 'components/popups/CommunicationPartnersCN'
import { useChat } from 'features/Chat'
import usePartnerProfileDialog from 'features/Partners/hooks/usePartnerProfileDialog'

const SidebarLocationProjectPartners = ({ location, project, assetOwner, assetName, projectPartners, userId }) => {
	const { state } = useChat()
	const [openPopup, setOpenPopup] = useState(false)
	const { openPartner, partnerDialog } = usePartnerProfileDialog()

	if (!location || !project || !assetOwner) {
		return null
	}

	const owner = [
		{
			id: assetOwner._id,
			image: assetOwner.image,
			name: assetOwner.name,
			email: assetOwner.email,
			title: assetOwner.title,
			company: assetOwner.company,
			isAccepted: true,
			owner: true,
			emailOption: '',
		},
	]

	const partners = (projectPartners || []).map(item => {
		if (item) {
			return {
				id: item.partnerUserId._id,
				image: item.partnerUserId.image,
				name: item.partnerUserId.name,
				firstName: item.partnerUserId.firstName,
				email: item.partnerUserId.email,
				title: item.partnerUserId.title,
				company: item.partnerUserId.company,
				isAccepted: true,
				owner: false,
				emailOption: '',
			}
		}
		return {}
	})

	const allPartners = [...owner, ...partners]
	const isEmpty = allPartners?.length === 0

	return (
		<>
			{/* Sized to its content so Project Activity below can claim the rest. */}
			<div className="flex flex-col flex-shrink-0">
				<div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between">
					<span className="flex items-center gap-2 text-gray-600 text-base font-semibold">
						<Users className="w-4 h-4" /> Project Partners
					</span>
					<button
						type="button"
						onClick={() => setOpenPopup(true)}
						className="text-gray-500 hover:text-gray-700 bg-transparent border-none cursor-pointer p-0"
						aria-label="Partner Communications"
					>
						<Mail className="w-5 h-5" />
					</button>
				</div>
				<div className="overflow-y-auto max-h-[240px]">
					{isEmpty ? (
						<div className="flex items-center justify-center p-4">
							<h3 className="text-[#0080fe] opacity-30 text-sm font-light text-center">
								No Partners
							</h3>
						</div>
					) : (
						<div>
							{allPartners.map((partner, index) => (
								<button
									key={index}
									type="button"
									// Your own row (you as originator) has no profile to open.
									disabled={String(partner.id) === String(userId)}
									onClick={() => openPartner(partner.id, partner)}
									className="w-full flex items-center px-4 py-2 text-left hover:bg-gray-50 disabled:hover:bg-transparent disabled:cursor-default"
								>
									<Avatar className="h-9 w-9 mr-3 shrink-0">
										<AvatarImage src={partner.image} />
										<AvatarFallback />
									</Avatar>
									<div className="flex-1 min-w-0">
										<div className="text-sm text-gray-900 truncate">{partner.name}</div>
										<div className="text-xs text-gray-500 truncate">
											{partner.isAccepted
												? `${partner.title || ''}${partner.company ? ` - ${partner.company}` : ''}${partner.owner ? ' (project originator)' : ''}`
												: 'Pending'}
										</div>
									</div>
								</button>
							))}
						</div>
					)}
				</div>
			</div>
			<CommunicationPartnersCN
				open={openPopup}
				onClose={() => setOpenPopup(false)}
				partners={allPartners}
				assetName={assetName}
			/>
			{partnerDialog}
		</>
	)
}

export default SidebarLocationProjectPartners
